import React from "react"
import "./TrialExpiryPage.css"
import "./PlanOptions.css"
import PlanDetails from "./PlanDetails.js"
import Orange from "../../assets/Orange.png"

function TrialExpiryPage({ history, dashboard, trial }) {
  return (
    <React.Fragment>
      <div className={`trial ${dashboard && "dashboard"}`}>
        <div className="trial-header">
          {!dashboard &&
            (trial ? (
              <h1>Your 30-day trial has expired</h1>
            ) : (
              <>
                <img alt="Qarabao Logo" src={Orange} />
                <h1>Get 30 days FREE for all plans</h1>
                <p>Billing for all plans occurs on a monthly basis.</p>
              </>
            ))}
        </div>
        {trial && (
          <p className="text">
            We hope you enjoyed using your free Qarabao trial! You may export
            any remaining data, but you won't be able to add or update anything
            until you complete your subscription. To continue, please select a
            plan below.
          </p>
        )}
        <PlanDetails
          dashboard={dashboard}
          user={history && history.location.state}
        />
      </div>
    </React.Fragment>
  )
}

export default TrialExpiryPage
